import { useState } from 'react';
import { formatFechaTicket, imprimirTicketDeepLink, LOGO_URL } from '../../utils/ticketBluetooth';

const Ticket = ({ data, onCerrar }) => {
    const [error, setError] = useState(null);

    const { folio, fecha, vendedor, sucursal, metodo, cobrado, carrito, total } = data;

    const handleImprimirAndroid = () => {
        setError(null);
        try {
            imprimirTicketDeepLink({ folio, fecha, vendedor, sucursal, metodo, cobrado, carrito, total });
            onCerrar();
        } catch (err) {
            setError('No se pudo abrir la app de impresión. Verifica que esté instalada.');
        }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.container}>
                {/* Preview visual del ticket */}
                <div style={styles.ticket}>
                    <div style={{ textAlign: 'center', marginBottom: '0.3rem' }}>
                        <img src={LOGO_URL} alt="Papa Roll" style={{ width: '50%', display: 'inline-block' }} />
                    </div>
                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    <div style={styles.linea}>{formatFechaTicket(fecha)}</div>
                    <div style={styles.linea}>Folio: {folio}</div>
                    <div style={styles.linea}>Vendedor: {vendedor}</div>
                    <div style={styles.linea}>Sucursal: {sucursal}</div>

                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    {carrito.map((item, idx) => (
                        <div key={idx} style={{ marginBottom: '0.4rem' }}>
                            <div style={styles.itemNombre}>
                                {item.nombre} x{item.cantidad}
                                {cobrado && (
                                    <span style={{ float: 'right' }}>
                                        ${(item.precio_total * item.cantidad).toFixed(2)}
                                    </span>
                                )}
                            </div>
                            {(item.extras || []).map((e, i) => (
                                <div key={i} style={styles.extra}>
                                    {'>> '}{e.nombre}
                                    {cobrado && <span style={{ float: 'right' }}>+${e.precio.toFixed(2)}</span>}
                                </div>
                            ))}
                        </div>
                    ))}

                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    {cobrado && (
                        <>
                            <div style={styles.total}>
                                TOTAL
                                <span style={{ float: 'right' }}>${total.toFixed(2)}</span>
                            </div>
                            {metodo && <div style={styles.linea}>Metodo: {metodo}</div>}
                        </>
                    )}

                    <div style={styles.sep}>{'-'.repeat(32)}</div>
                </div>

                {/* Estado / error */}
                {error && (
                    <div style={styles.errorBox}>
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error}
                    </div>
                )}

                {/* Botones */}
                <div style={styles.botones}>
                    <button style={styles.btnImprimir} onClick={handleImprimirAndroid}>
                        <i className="fas fa-print me-2"></i>
                        Imprimir
                    </button>
                    <button style={styles.btnCerrar} onClick={onCerrar}>
                        <i className="fas fa-times me-2"></i>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '1rem',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
    ticket: {
        background: '#fff',
        color: '#111',
        width: '220px',
        padding: '1rem',
        fontFamily: 'monospace',
        fontSize: '11px',
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    },
    titulo: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '16px',
        marginBottom: '0.3rem',
        letterSpacing: '1px',
    },
    sep: {
        color: '#bbb',
        margin: '0.35rem 0',
        overflow: 'hidden',
        fontSize: '10px',
    },
    linea: {
        margin: '0.15rem 0',
        lineHeight: 1.4,
    },
    itemNombre: {
        fontWeight: 'bold',
        lineHeight: 1.4,
    },
    extra: {
        paddingLeft: '0.75rem',
        color: '#555',
        lineHeight: 1.4,
    },
    total: {
        fontWeight: 'bold',
        fontSize: '13px',
        margin: '0.3rem 0',
    },
    errorBox: {
        background: 'rgba(229,62,62,0.15)',
        border: '1px solid rgba(229,62,62,0.4)',
        borderRadius: '8px',
        color: '#E53E3E',
        fontSize: '0.82rem',
        padding: '0.65rem 1rem',
        maxWidth: '260px',
        textAlign: 'center',
    },
    botones: {
        display: 'flex',
        gap: '0.75rem',
    },
    btnAndroid: {
        background: '#1A73E8',
        color: '#fff',
        border: 'none',
        borderRadius: '10px',
        padding: '0.75rem 1.5rem',
        fontWeight: 800,
        fontSize: '1rem',
        cursor: 'pointer',
    },
    btnImprimir: {
        background: '#F5C800',
        color: '#111',
        border: 'none',
        borderRadius: '10px',
        padding: '0.75rem 1.5rem',
        fontWeight: 800,
        fontSize: '1rem',
        cursor: 'pointer',
    },
    btnCerrar: {
        background: 'transparent',
        color: '#888',
        border: '1px solid #444',
        borderRadius: '10px',
        padding: '0.75rem 1.5rem',
        fontWeight: 700,
        fontSize: '1rem',
        cursor: 'pointer',
    },
};

export default Ticket;
